import { STEP_WEIGHT } from './STEP_WEIGHT';

/**
 * @param currentProgress
 * @returns progress that is at max 95% and gives each step a weight of 5%,
 * this is temporary until we have progress information given by BE
 */
export const ceiledIncrement: (currentProgress: number, weight?: number) => number = (
	currentProgress,
	weight = STEP_WEIGHT,
) => Math.min(0.95, currentProgress + 0.95 * weight);
